export function generateId() {
    return crypto.randomUUID();
}
//# sourceMappingURL=generateId.js.map